import React from 'react'
import { component_tool, framework_tool } from "@/tool";
const { WizBrowserExport } = component_tool

export const handleExport = ({ title, column }, nextProps, nextState, key) => {
  const res = nextProps[key]
  const { success, data = {}, msg } = res
  const { dataList = [], headList = [] } = data
  if (success) {
    const rows = dataList
    let headList_ = [];
    if (headList && headList.length) {
      headList.forEach(val => {
        const { name, list } = val;
        if (list && list.length) {
          let list_new = [];
          list.forEach(val_ => {
            if (val_) {
              list_new.push(val_);
            }
            val.list = list_new;
          })
        }
        headList_.push(val);
      })
    }
    const _columns = headList_.map(val => ({
      headerName: val.name,
      field: val.key,
      children: val.list && val.list.length ? val.list.map(val => ({
        headerName: val.name,
        field: val.key
      })) : undefined
    }))

    WizBrowserExport({
      title,
      sheetName: title,
      columns: column.filter((_, index) => index).concat(_columns),
      rows,
      filename: title + '.xlsx',
    })
    return true
  } else {
    wizNotice.error(msg)
    return false;
  }
}

export function mergeColumns(columns) {
  const { dynamicColumns } = this.props
  let dynamicColumns_new = [];
  if (dynamicColumns && dynamicColumns.length) {
    dynamicColumns.forEach(val => {
      const { name, list } = val;
      if (list && list.length) {
        let list_new = [];
        list.forEach(val_ => {
          if (val_) {
            list_new.push(val_);
          }
          val.list = list_new;
        })
      }
      dynamicColumns_new.push(val);
    })
  }
  const _dynamicColumns = dynamicColumns_new.map(val => ({
    title: val.name,
    name: val.key,
    tableItem: {
      children: val.list && val.list.length ? val.list.map(val => ({
        ...val,
        children: val.list && val.list.length ? val.list.map(val => ({
          ...val,
          dataIndex: val.key,
          title: val.name
        })) : undefined,
        dataIndex: val.key,
        title: val.name
      })
      ) : undefined,
    }
  }))

  return columns.concat(_dynamicColumns)
}
